import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useFilterConfig } from '../../hooks/useFilterConfig';
import { ToggleFilter } from '../reusableFilters/ToggleFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PortalInstallableFilter() {
  const {
    PORTAL_INSTALLABLE
  } = useFilterConfig();
  if (!PORTAL_INSTALLABLE) return null;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "400",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "label",
      htmlFor: PORTAL_INSTALLABLE.field,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.filters.universal.compatiblePlan.label"
      })
    }), /*#__PURE__*/_jsx(ToggleFilter, {
      filter: PORTAL_INSTALLABLE
    })]
  });
}